import React from "react";
import SumInsuredHeader from "./SumInsuredHeader";
import GradeAttributes from "./GradeAttributes";
import CoverageNotes from "./CoverageNotes";
import { motion } from "framer-motion";

function GradeView({ grade }) {

  let companiesWithNoGrades = ["Dover India Private Limited"]
  let currentComp = localStorage.getItem("company_name")

  return (
    <motion.div
      style={{
        borderRadius: "10px",
        // background: "white",
        // padding: "40px",
      }}
      initial={{
        opacity: 0,
        y: -20,
      }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.2 }}
    >
      <SumInsuredHeader
        sumInsured={                                           //sum insured = {'3x of CTC'}
          grade?.sum_insured?.data?.values?.length
            ? grade?.sum_insured?.data?.values
            : [grade?.sum_insured?.data?.default]
        }
        min = {grade?.sum_insured?.data.min}
        max = {grade?.sum_insured?.data.max}
        defaultSumInsured={grade?.sum_insured?.data?.default}           //default = 3x of CTC
        dependents={grade?.dependents}
      />
      {companiesWithNoGrades.includes(currentComp) ? null : <GradeAttributes attributes={grade?.attributes} /> }
      {/* <GradeAttributes attributes={grade?.attributes} /> */}
      <CoverageNotes title="What is Not Covered?" notes={grade?.exclusions} />
      <CoverageNotes title="Coverage Notes" notes={grade?.coverage_notes} />
    </motion.div>
  );
}

export default GradeView;
